<template>  
  <div id="app">  
    <div class="form-container">  
      <h1>Zbor građana Bagljaš</h1>  
      <h2>Spreman sam da pomognem</h2>  
      <form @submit.prevent="submitForm">  
        <div class="form-group tooltip-container" :class="{'has-error': communityError}">  
          <select v-model="form.community" required class="full-width">  
            <option value="" disabled>Izaberite mesnu zajednicu</option>  
            <option value="MZ Sonja Marinković">MZ Sonja Marinković</option>  
            <option value="МZ Veljko Vlahović">МZ Veljko Vlahović</option>  
          </select>  
          <span v-if="communityError" class="tooltip">{{ communityError }}</span>  
        </div>  
        <div class="form-group">  
          <input type="text" id="firstName" v-model="form.firstName" placeholder="Ime" required class="full-width" />  
        </div>  
        <div class="form-group">  
          <input type="text" id="lastName" v-model="form.lastName" placeholder="Prezime" required class="full-width" />  
        </div>  
        <div class="form-group">  
          <input type="text" id="occupation" v-model="form.occupation" placeholder="Zanimanje" required class="full-width" />  
        </div>  
        <div class="form-group tooltip-container" :class="{'has-error': phoneError}">  
          <input type="text" id="phone" v-model="form.phone" placeholder="Telefon (opcionalno)" @input="validatePhone" class="full-width" />  
          <span v-if="phoneError" class="tooltip">{{ phoneError }}</span>  
        </div>  
        <div class="form-group">  
          <input type="email" id="email" v-model="form.email" placeholder="Email (opcionalno)" class="full-width" />  
          <span v-if="emailError" class="error">{{ emailError }}</span>  
        </div>  
        <div class="form-group checkbox-group">  
          <h3 class="checkbox-title">Prijavljujem se za radnu grupu (opcionalno)</h3>  
          <div class="checkbox-container">  
            <label><input type="checkbox" v-model="form.logistics" /> Logistika</label>  
            <label><input type="checkbox" v-model="form.security" /> Bezbednost</label>  
            <label><input type="checkbox" v-model="form.media" /> Mediji</label>  
            <label><input type="checkbox" v-model="form.studentCooperation" /> Saradnja sa studentima</label>  
            <label><input type="checkbox" v-model="form.educationCooperation" /> Saradnja sa prosvetom</label>  
            <label><input type="checkbox" v-model="form.other" /> Ostalo</label>  
          </div>  
        </div>  
        <div class="form-group checkbox-group">  
          <input type="checkbox" id="consent" v-model="form.consent" required />  
          <label for="consent">Slažem se da se moji podaci prikupe od strane Zbora građana Bagljaš u svrhu pomoći u aktivnostima zbora. Zbor me može kontaktirati ukoliko bude potrebno.</label>  
        </div>  
        <button type="submit" class="full-width" :disabled="loading">  
          <span v-if="loading" class="loading-dots">  
            <span class="dot"></span>  
            <span class="dot"></span>  
            <span class="dot"></span>  
          </span>  
          <span v-else>Pošalji</span>  
        </button>  
      </form>  
      <!-- Success Modal -->  
      <div v-if="showSuccessModal" class="modal-backdrop" @click="closeModal">  
        <div class="modal-content" @click.stop>  
          <h3>Hvala vam na podršci! 🙏</h3>  
          <p>Vaši podaci su uspešno sačuvani.</p>  
          <button class="modal-close" @click="closeModal">Zatvori</button>  
        </div>  
      </div>  
    </div>  
  </div>  
</template>  
  
<script>  
import axios from 'axios';  
  
export default {  
  data() {  
    return {  
      showSuccessModal: false,  
      loading: false,  
      form: {  
        community: '',  
        firstName: '',  
        lastName: '',  
        phone: '',  
        email: '',  
        occupation: '',  
        logistics: false,  
        security: false,  
        media: false,  
        studentCooperation: false,  
        educationCooperation: false,  
        other: false,  
        consent: false,  
      },  
      emailError: '',  
      phoneError: '',  
      communityError: ''  
    };  
  },  
  methods: {  
    validateForm() {  
      let valid = true;  
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;  
      const phonePattern = /^\d*$/;  
  
      if (this.form.email && !emailPattern.test(this.form.email)) {  
        this.emailError = 'Email nije validan';  
        valid = false;  
      } else {  
        this.emailError = '';  
      }  
  
      if (this.form.phone && !phonePattern.test(this.form.phone)) {  
        this.phoneError = 'Telefon mora sadržati samo numeričke vrednosti';  
        valid = false;  
      } else {  
        this.phoneError = '';  
      }  
  
      if (!this.form.community) {  
        this.communityError = 'Izaberite vašu mesnu zajednicu';  
        valid = false;  
      } else {  
        this.communityError = '';  
      }  
  
      return valid;  
    },  
    validatePhone() {  
      const phonePattern = /^\d*$/;  
      this.phoneError = phonePattern.test(this.form.phone) ? '' : 'Telefon mora sadržati samo numeričke vrednosti';  
    },  
    async submitForm() {  
      if (!this.validateForm()) {  
        return;  
      }  
      this.loading = true;  
      try {  
        // Get client IP address  
        const ipResponse = await axios.get('https://api.ipify.org?format=json');  
        const ipAddress = ipResponse.data.ip;  
  
        const data = {  
          cityArea: this.form.community,  
          firstName: this.form.firstName,  
          lastName: this.form.lastName,  
          occupation: this.form.occupation,  
          email: this.form.email,  
          phone: this.form.phone,  
          detectedIpAddress: ipAddress,  
          logistics: this.form.logistics,  
          security: this.form.security,  
          media: this.form.media,  
          studentCooperation: this.form.studentCooperation,  
          educationCooperation: this.form.educationCooperation,  
          other: this.form.other,  
        };  
  
        await axios.post('https://helpregistry8551334330.azurewebsites.net/api/StorePersonData?code=vAKWOG0lOndgJYOdhRiv75IdYem0nafN2JU9KwKLR6XkAzFupPe4hA==', data);  
        console.log('Podaci su uspešno poslati');  
        this.showSuccessModal = true;  
        this.resetForm();  
      } catch (error) {  
        console.error('Greška:', error);  
        if (error.response) {  
          console.error('Server error:', error.response.data);  
        } else if (error.request) {  
          console.error('No response received:', error.request);  
        } else {  
          console.error('Request setup error:', error.message);  
        }  
      } finally {  
        this.loading = false;  
      }  
    },  
    resetForm() {  
      this.form = {  
        community: '',  
        firstName: '',  
        lastName: '',  
        phone: '',  
        email: '',  
        occupation: '',  
        logistics: false,  
        security: false,  
        media: false,  
        studentCooperation: false,  
        educationCooperation: false,  
        other: false,  
        consent: false,  
      };  
      this.emailError = '';  
      this.phoneError = '';  
      this.communityError = '';  
    },  
    closeModal() {  
      this.showSuccessModal = false;  
    }  
  },  
};  
</script>  
  
<style>  
/* CSS Reset */  
* {  
  margin: 0;  
  padding: 0;  
  box-sizing: border-box;  
}  
  
html, body {  
  width: 100%;  
  height: 100%;  
  background-color: #1a1a1a; /* Set background color here if needed */  
}  
  
#app {  
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;  
  background-color: #1a1a1a;  
  min-height: 100vh;  
  display: flex;  
  justify-content: center;  
  align-items: center;  
  padding: 1rem;  
}  
  
.form-container {  
  background-color: #2d2d2d;  
  border-radius: 12px;  
  padding: 2rem;  
  width: 100%;  
  max-width: 600px;  
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);  
}  
  
h1 {  
  color: #ffffff;  
  font-size: 2rem;  
  font-weight: 700;  
  margin-bottom: 0.5rem;  
  text-align: center;  
}  
  
h2 {  
  color: #d4d4d4;  
  font-size: 1.25rem;  
  font-weight: 400;  
  text-align: center;  
  margin-bottom: 2rem;  
}  
  
.form-group {  
  margin-bottom: 1.5rem;  
}  
  
input[type="text"], input[type="email"], select {  
  padding: 1rem;  
  background-color: #404040;  
  border: 1px solid #404040;  
  border-radius: 8px;  
  color: #ffffff;  
  font-size: 1rem;  
  transition: all 0.2s ease;  
}  
  
.full-width {  
  width: 100%;  
}  
  
select {  
  appearance: none;  
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");  
  background-repeat: no-repeat;  
  background-position: right 1rem center;  
  background-size: 1em;  
}  
  
::placeholder {  
  color: #858585;  
  opacity: 1;  
}  
  
select:invalid {  
  color: #858585;  
}  
  
option {  
  color: #ffffff;  
  background-color: #404040;  
}  
  
input:focus, select:focus {  
  outline: none;  
  border-color: #007acc;  
  box-shadow: 0 0 0 3px rgba(0, 122, 204, 0.2);  
  background-color: #2d2d2d;  
}  
  
.checkbox-group {  
  display: flex;  
  flex-direction: column;  
  align-items: flex-start;  
  gap: 0.75rem;  
  padding: 1rem;  
  background-color: #40404040;  
  border-radius: 8px;  
}  
  
.checkbox-title {  
  color: #b0b0b0;  
  font-size: 1rem;  
  margin-bottom: 0.5rem;  
}  
  
input[type="checkbox"] {  
  width: 1.25rem;  
  height: 1.25rem;  
  accent-color: #007acc;  
  flex-shrink: 0;  
  margin-top: 0.25rem;  
}  
  
.checkbox-group label {  
  color: #b0b0b0;  
  font-size: 0.9rem;  
  line-height: 1.5;  
}  
  
.checkbox-container {  
  display: flex;  
  flex-direction: column;  
  gap: 0.5rem;  
}  
  
button {  
  width: 100%;  
  padding: 1rem;  
  background-color: #007acc;  
  color: #ffffff;  
  border: none;  
  border-radius: 8px;  
  font-size: 1rem;  
  font-weight: 600;  
  cursor: pointer;  
  transition: background-color 0.2s ease;  
}  
  
button:disabled {  
  background-color: #3a7ca6;  
  cursor: not-allowed;  
}  
  
.loading-dots {  
  display: flex;  
  justify-content: center;  
  align-items: center;  
}  
  
.loading-dots .dot {  
  width: 8px;  
  height: 8px;  
  background-color: #ffffff;  
  border-radius: 50%;  
  margin: 0 3px;  
  animation: loading-animation 0.6s infinite;  
}  
  
.loading-dots .dot:nth-child(1) {  
  animation-delay: 0s;  
}  
  
.loading-dots .dot:nth-child(2) {  
  animation-delay: 0.2s;  
}  
  
.loading-dots .dot:nth-child(3) {  
  animation-delay: 0.4s;  
}  
  
@keyframes loading-animation {  
  0% {  
    transform: scale(1);  
  }  
  50% {  
    transform: scale(1.5);  
  }  
  100% {  
    transform: scale(1);  
  }  
}  
  
button:hover:not(:disabled) {  
  background-color: #0066b3;  
}  
  
.tooltip-container {  
  position: relative;  
}  
  
.tooltip {  
  position: absolute;  
  top: 100%;  
  left: 0;  
  transform: translateY(0.5rem);  
  background-color: #e74c3c;  
  color: white;  
  padding: 0.5rem;  
  border-radius: 4px;  
  font-size: 0.875rem;  
  white-space: nowrap;  
  z-index: 1;  
  display: none;  
}  
  
.has-error .tooltip {  
  display: block;  
}  
  
@media (max-width: 480px) {  
  .form-container {  
    padding: 1.5rem;  
  }  
  h1 {  
    font-size: 1.75rem;  
  }  
  h2 {  
    font-size: 1.1rem;  
  }  
}  
  
.modal-backdrop {  
  position: fixed;  
  top: 0;  
  left: 0;  
  width: 100%;  
  height: 100%;  
  background-color: rgba(0, 0, 0, 0.7);  
  display: flex;  
  justify-content: center;  
  align-items: center;  
  z-index: 1000;  
}  
  
.modal-content {  
  background-color: #2d2d2d;  
  padding: 2rem;  
  border-radius: 12px;  
  text-align: center;  
  max-width: 400px;  
  width: 90%;  
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);  
}  
  
.modal-content h3 {  
  color: #ffffff;  
  font-size: 1.5rem;  
  margin-bottom: 1rem;  
}  
  
.modal-content p {  
  color: #d4d4d4;  
  margin-bottom: 1.5rem;  
}  
  
.modal-close {  
  background-color: #007acc;  
  padding: 0.75rem 1.5rem;  
  border-radius: 6px;  
  font-weight: 500;  
  transition: background-color 0.2s ease;  
}  
  
.modal-close:hover {  
  background-color: #0066b3;  
}  
</style>  